
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class PurchaseOrderInTransitService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.po_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_PI_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getPurchaseOrderInTransitPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderInTransitPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPurchaseOrderInTransit(input, responseCallBack, errorCallBack) {
    this.method(
      "createPurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPurchaseOrderInTransit(input, responseCallBack, errorCallBack) {
    this.method(
      "readPurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePurchaseOrderInTransit(input, responseCallBack, errorCallBack) {
    this.method(
      "updatePurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initPurchaseOrderInTransitModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initPurchaseOrderInTransitModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockPurchaseOrderInTransit(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockPurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApprovePurchaseOrderInTransit(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unApprovePurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approvePurchaseOrderInTransit(input, responseCallBack, errorCallBack) {
    this.method(
      "approvePurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPurchaseOrderInTransit(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelPurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderInTransitInputFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderInTransitInputFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderInTransitRollPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderInTransitRollPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInTransitSummaryDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getInTransitSummaryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPurchaseOrderInTransitRollLine(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelPurchaseOrderInTransitRollLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPurchaseOrderInTransitLine(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelPurchaseOrderInTransitLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockPurchaseOrderInTransit(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockPurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelAndUnLockPurchaseOrderInTransitAfterApproval(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelAndUnLockPurchaseOrderInTransitAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelAndUnLockPurchaseOrderInTransit(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelAndUnLockPurchaseOrderInTransit",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorPurchaseOrderInTransitDetailsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getVendorPurchaseOrderInTransitDetailsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static uploadExcelInput(input, responseCallBack, errorCallBack) {
    this.method("uploadExcelInput", input, responseCallBack, errorCallBack);
  }
  static getPurchaseOrderInTransitForPurchaseOrder(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderInTransitForPurchaseOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static purchaseOrderInTransitImageUpload(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "purchaseOrderInTransitImageUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static purchaseOrderInTransitDocUpload(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "purchaseOrderInTransitDocUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // axios({
      //   method: "post",
      //   url: this.po_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });

      ServiceExecutorProxy.executeService(methodName, input,this.po_data_url,responseCallBack, errorCallBack);
    }
  }
}
